import { Dropdown, Option, OptionOnSelectData, SelectionEvents } from "@fluentui/react-components";
import { FunctionComponent } from "react";
import { AVAILABLE_VALIDATORS } from "../../constants/config";

export const ValidatorDropdown: FunctionComponent<{ validator: string, onValidatorSelected: (ev: SelectionEvents, data: OptionOnSelectData) => void }> = ({validator, onValidatorSelected}) => {

    return (<><div className="validator">Validator: &nbsp;</div>
        <Dropdown size='small' value={validator} selectedOptions={[validator]} className="dropdown" onOptionSelect={onValidatorSelected}>
            {AVAILABLE_VALIDATORS.map((v) => (
                <Option key={v.value} text={v.value} value={v.value}>
                    <span title={v.description} className="dropdown-item">{v.value}</span>
                </Option>
            ))}
        </Dropdown>
    </>)
}